/*
  CRO 2026-09-25: free 15 ml varnish on orders of Rs.2,599+.
  Adds the varnish (tagged with the hidden line property _free_gift) once what the shopper chose
  reaches the threshold. A Shopify automatic discount makes it Rs.0; this script only puts it in
  the cart. If the cart later drops below the threshold the varnish stays and is charged Rs.79.
  Does nothing if the shopper already added the 15 ml varnish themselves.
  Config comes from window.CRO_OFFERS, set in snippets/cro-cart-reassurance.liquid.
*/
(() => {
  if (window.__croFreeGift) return;
  window.__croFreeGift = true;

  const cfg = window.CRO_OFFERS;
  if (!cfg) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isGift = (item) => item.properties && item.properties._free_gift;
  let busy = false;
  let again = false;

  const post = (url, body) =>
    fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });

  async function refreshCartUI() {
    if (document.querySelector('cart-items:not(cart-drawer-items)')) {
      window.location.reload(); // cart page: simplest way to re-render every section
      return;
    }
    const res = await fetch(`${root}?sections=cart-drawer,cart-icon-bubble`);
    const sections = await res.json();
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

    const drawer = document.querySelector('cart-drawer');
    const current = document.querySelector('#CartDrawer');
    const fresh = sections['cart-drawer'] && parse(sections['cart-drawer']).querySelector('#CartDrawer');
    if (drawer && current && fresh) {
      current.innerHTML = fresh.innerHTML;
      drawer.classList.remove('is-empty');
      const overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    const bubble = document.getElementById('cart-icon-bubble');
    const freshBubble = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
    if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
  }

  async function sync() {
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    try {
      const cart = await (await fetch(`${root}cart.js`)).json();
      const gift = cart.items.find(isGift);
      const chosen = cart.items.filter((i) => !isGift(i));
      const base = chosen.reduce((sum, i) => sum + i.original_line_price, 0);
      const ownVarnish = chosen.some((i) => i.variant_id === cfg.giftVariant);
      let changed = false;

      if (!gift && !ownVarnish && chosen.length && base >= cfg.giftMin) {
        const r = await post('cart/add.js', {
          items: [{ id: cfg.giftVariant, quantity: 1, properties: { _free_gift: '1' } }],
        });
        changed = r.ok;
      } else if (gift && (ownVarnish || !chosen.length)) {
        // Below the threshold the varnish stays and is charged (Vishal, 2026-09-25); it only goes
        // when the shopper added their own or emptied the rest of the cart.
        changed = (await post('cart/change.js', { id: gift.key, quantity: 0 })).ok;
      } else if (gift && gift.quantity > 1) {
        changed = (await post('cart/change.js', { id: gift.key, quantity: 1 })).ok;
      }

      if (changed) await refreshCartUI();
    } catch (e) {
      console.warn('[cro-free-gift]', e);
    } finally {
      busy = false;
      if (again) {
        again = false;
        sync();
      }
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(sync, 50));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
